<template>
  <ExternalQueryList
      headline="Content Article Categories"
      endpoint="/api/v2/content-article-categories"
      :endpoint-filters="{portal_id: portal.id}"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      @show="contentArticleCategory => $router.push(getUrl(contentArticleCategory))"
  >
    <template v-slot:default="{ row: contentArticleCategory }">
      <td>
        <router-link :to="getUrl(contentArticleCategory)">
          {{ contentArticleCategory.attributes.name }}
        </router-link>

        <span v-if="!contentArticleCategory.attributes.is_active" class="label label-warning">
          Inactive
        </span>
      </td>

      <td>
          {{ contentArticleCategory.attributes.path }}
      </td>
    </template>

    <template v-slot:headline-right>
      <router-link
          class="btn btn-white btn-sm"
          style="margin-top: 4px;"
          :to="'/portals/' + portal.id + '/content/article-categories/create'"
      >
        <i class="fa fa-plus"></i> Create
      </router-link>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  props: {
    portal: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 10, text: 'Name'},
        {width: 10, text: 'Path'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(contentArticleCategory) {
      return '/portals/' + this.portal.id + '/content/article-categories/' + contentArticleCategory.id + '/edit'
    }
  }
}
</script>
